import React from "react";
import "./template4-header.css";
import { ApiUrl } from "../../../../consts/api";
import { useDispatch, useSelector } from "react-redux";
import { getCompany } from "../../../../react-reduxs/slices/companies/company_slice";
import { getCategoryList } from "../../../../react-reduxs/slices/categories/category_slice";
import {
  categoryIdChange,
  getProductSelectedCategoryId,
} from "../../../../react-reduxs/slices/products/product_slice";

const Template4Header: React.FC = () => {
  const dispatch = useDispatch();
  const company = useSelector(getCompany);
  const categoryList = useSelector(getCategoryList);
  const selectCategoryId = useSelector(getProductSelectedCategoryId);
  const logoSrc = company?.logo
    ? `${ApiUrl}/${company.logo}`
    : "/images/category.png";

  const showTableBadge = company?.tableName;

  return (
    <header
      className="hdr__wrap"
      onClick={() => {
        dispatch(categoryIdChange(""));
      }}
    >
      {/* ── Main row ── */}
      <div className="hdr__inner">
        {/* Logo */}
        <div className="hdr__logo-wrap">
          <img
            className="hdr__logo"
            src={logoSrc}
            alt={company?.title ?? "Logo"}
          />
        </div>

        {/* Centered title + active category */}
        <div className="hdr__title-block">
          <h1 className="hdr__title">{company?.title}</h1>
          {company?.title && <span className="hdr__subtitle">Menü</span>}
          {selectCategoryId && (
            <span className="hdr__category-badge">
              <i className="fa-solid fa-utensils hdr__cat-icon" />
              {categoryList.find((x) => x.id === selectCategoryId)?.name}
            </span>
          )}
        </div>

        {/* Table badge — pushes to right via margin-left:auto in CSS */}
        {showTableBadge && (
          <div className="hdr__table-badge">
            <i className="fa-solid fa-chair" />
            <span className="hdr__table-label">{company.tableName}</span>
          </div>
        )}
      </div>

      {/* Decorative accent line */}
      <div className="hdr__accent-bar" />
    </header>
  );
};

export default Template4Header;
